<template>
  <div>
    <div class="mt-2 text-caption text-center grey--text">
      Preview: How the text question will appear to users
    </div>
    <div class="open-text-question">
      <div v-if="title" class="text-subtitle-1 font-weight-medium mb-2">{{ title }}</div>
      <div v-if="description" class="text-body-2 mb-3">{{ description }}</div>
      <v-textarea
        :placeholder="placeholder || 'Enter your response here...'"
        rows="3"
        readonly
        outlined
        hide-details
        class="preview-textarea"
      ></v-textarea>
    </div>
  </div>
</template>

<script>
export default {
  name: "OpenTextQuestion",

  props: {
    title: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
.open-text-question {
  padding: 16px;
  border-radius: 4px;
  background-color: #f5f5f5;
  max-width: 300px;
  margin: 0 auto;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.preview-textarea {
  background-color: white;
  width: 100%;
}
</style>
